import { Badge, LuIcon, Menu, type MenuGroupProps, Text } from "@overmap-ai/blocks"
import type { Stored, User } from "@overmap-ai/common"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { getUserDisplayLabel } from "../../utils/users"
import { UserIcon } from "../Icons/UserIcon"

export interface AssigneeGroupProps extends MenuGroupProps {
	assignees: (Stored<User> | null)[]
	onSelectAssignee: (assignee: Stored<User> | null) => void
}

export const AssigneeGroup = memo<AssigneeGroupProps>((props) => {
	const { ref, assignees, onSelectAssignee, ...rest } = props

	return (
		<Menu.Group ref={ref} {...rest}>
			{assignees.map((assignee) => (
				<Menu.Item key={assignee?.id ?? "unassigned"} onSelect={() => onSelectAssignee(assignee)}>
					{assignee ? (
						<>
							<UserIcon userId={assignee.id} size="xs" />
							<Text className="truncate">{getUserDisplayLabel(assignee)}</Text>
						</>
					) : (
						<>
							<Badge size="xs" icon radius="full" accentColor="base" variant="soft">
								<LuIcon icon={modelIconMapping.unassigned} />
							</Badge>
							<span className="truncate">Unassigned</span>
						</>
					)}
				</Menu.Item>
			))}
		</Menu.Group>
	)
})
AssigneeGroup.displayName = "AssigneeGroup"
